export default "__VITE_ASSET__8bca0e6f__"